import {
  differenceInDays,
  differenceInHours,
  differenceInMinutes,
} from "date-fns";

const checkDateisValid = (date: any): boolean => {
  if (Object.prototype.toString.call(date) === "[object Date]") {
    return isNaN(date.getTime());
  }
  return false;
};

const getCalculatedDelay = (
  currentDate: Date,
  dateToCompareWith: Date,
  translations: { [key: string]: string }
): string => {
  const {
    noDelay,
    calculationError,
    singleDayTranslation,
    pluralDayTranslation,
    singleHourTranslation,
    pluralHourTranslation,
    singleMinuteTranslation,
    pluralMinuteTranslation,
  } = translations;

  const daysDiff: number = differenceInDays(currentDate, dateToCompareWith);
  const hoursDiff: number =
    differenceInHours(currentDate, dateToCompareWith) - daysDiff * 24;
  const minutesDiff: number =
    differenceInMinutes(currentDate, dateToCompareWith) -
    daysDiff * 24 * 60 -
    hoursDiff * 60;
  if (checkDateisValid(dateToCompareWith)) {
    return calculationError;
  }

  if (
    (daysDiff === 0 && hoursDiff === 0 && minutesDiff === 0) ||
    daysDiff < 0 ||
    hoursDiff < 0 ||
    minutesDiff < 0
  ) {
    return noDelay;
  } else {
    const dayTranslation: string =
      daysDiff > 0
        ? daysDiff === 1
          ? `${daysDiff} ${singleDayTranslation}`
          : `${daysDiff} ${pluralDayTranslation}`
        : "";
    const hourTranslation: string =
      hoursDiff > 0
        ? hoursDiff === 1
          ? `${hoursDiff} ${singleHourTranslation}`
          : `${hoursDiff} ${pluralHourTranslation}`
        : "";
    const minuteTranslation: string =
      minutesDiff > 0
        ? minutesDiff === 1
          ? `${minutesDiff} ${singleMinuteTranslation}`
          : `${minutesDiff} ${pluralMinuteTranslation}`
        : "";
    const delay: string = `${dayTranslation} ${hourTranslation} ${minuteTranslation}`;
    return delay;
  }
};

export default getCalculatedDelay;
